export default class NoTokenError extends Error {
  constructor() {
    super('You are not logged in');
    this.name = 'NoTokenError';
  }
}
